define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/generator", "../../utils/tools", "../../models/E911DetailsModel", "../../models/PhoneNumberModel", "../../models/FaxSettingsModel", "../../models/RemovePhoneNumberModel", "../../models/BulkEditPhoneNumberModel", "../../models/UserContext", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, urls_1, generator_1, tools, E911DetailsModel, PhoneNumberModel, FaxSettingsModel, RemovePhoneNumberModel, BulkEditPhoneNumberModel, UserContext, LookupDataSources) {
    "use strict";
    var PhoneNumberActions = /** @class */ (function () {
        function PhoneNumberActions() {
            this.editE911DetailsModel = ko.observable(new E911DetailsModel());
            this.editPhoneModel = ko.observable(new PhoneNumberModel());
            this.editFaxSettingsModel = ko.observable(new FaxSettingsModel());
            this.bulkEditPhoneModel = ko.observable(new BulkEditPhoneNumberModel());
            this.removePhoneModel = ko.observable(new RemovePhoneNumberModel());
            this.userCanDeleteE911 = ko.observable(UserContext.hasAccess("Admin,E911.Delete"));
            this.userCanViewBrekeke = ko.observable(UserContext.hasAccess("Admin,Brekeke.View,Brekeke.Edit,Brekeke.Delete"));
            this.userCanEditBrekeke = ko.observable(UserContext.hasAccess("Admin,Brekeke.Edit,Brekeke.Delete"));
            this.userCanDeleteBrekeke = ko.observable(UserContext.hasAccess("Admin,Brekeke.Delete"));
            //userCanChangeCustomer = ko.observable<boolean>(UserContext.hasAccess("Admin,PhoneNumbers.AllowChangeCustomer"));
            this.userCanChangeCustomer = ko.observable(false);
            this.customerNumbers = ko.observableArray([]);
            this.bvnProviderId = 0;
            this.filteredStatuses = ko.observableArray([]);
            this.filteredProductTypes = ko.observableArray([]);
            this.includePhoneNumbers = false;
        }
        PhoneNumberActions.prototype.init = function () {
            var _this = this;
            console.log('phone numbers actions constructor');
            $(".js-add-phoneNumber").on("click", function (event) {
                var actionData = $(event.currentTarget).data();
                console.log('actions data: ', actionData);
                _this.editPhoneNumber(null, null, actionData.customerid, actionData.customername);
                return false;
            });
        };
        PhoneNumberActions.prototype.editPhoneNumber = function (phoneId, phoneNumber, customerId, customerName, btn) {
            var self = this;
            var title = "Add New Phone Number";
            if ($.isNumeric(phoneId) && phoneNumber) {
                title = "Edit ".concat(phoneNumber, " Details");
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editPhoneModel().Number()) {
                        tools.error("Phone number is required");
                        return;
                    }
                    var regularExpression = /^[a-zA-Z0-9]+$/;
                    var valid = regularExpression.test(self.editPhoneModel().Number());
                    if (!valid) {
                        tools.error("Phone number - digits and characters are allowed only");
                        return;
                    }
                    if (!self.editPhoneModel().PhoneNumberProviderId()) {
                        tools.error("Please select provider");
                        return;
                    }
                    if (self.bvnProviderId && self.bvnProviderId === self.editPhoneModel().PhoneNumberProviderId() && self.editPhoneModel().CustomerId() > 0 && !self.editPhoneModel().BTN()) {
                        tools.error("Please enter BTN number");
                        return;
                    }
                    var notValidCnam = tools.validateCNam(self.editPhoneModel().CNam());
                    if (notValidCnam) {
                        tools.error(notValidCnam);
                        return;
                    }
                    self.editPhoneModel().EntityName(self.domainsDropdown.value());
                    $(event.currentTarget).button("loading");
                    self.savePhoneNumber(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if ($.isNumeric(phoneId)) {
                        getModelCall = tools.ajaxGet({
                            url: urls_1.urls.getPhoneNumberById,
                            data: { id: phoneId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editPhoneModel(new PhoneNumberModel(result.Data));
                                    self.editPhoneModel().NumberEditReadonly(true);
                                    if (self.editPhoneModel().CustomerId()) {
                                        self.editPhoneModel().CustomerEditReadonly(!self.userCanChangeCustomer());
                                    }
                                    else {
                                        self.editPhoneModel().CustomerEditReadonly(false);
                                    }
                                    self.includePhoneNumbers = self.editPhoneModel().PhoneNumberProviderName().toLowerCase() == 'Bandwidth'.toLowerCase();
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editPhoneModel(new PhoneNumberModel());
                        self.editPhoneModel().CustomerId(customerId);
                        self.editPhoneModel().CustomerName(customerName);
                        self.editPhoneModel().BTN(btn);
                        self.editPhoneModel().NumberEditReadonly(false);
                        self.editPhoneModel().CustomerEditReadonly(false);
                        if (phoneNumber) {
                            self.editPhoneModel().Number(phoneNumber);
                        }
                    }
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: urls_1.urls.getPhoneGetLookupData,
                        data: { customerId: customerId },
                        success: function (data) {
                            if (data.Success) {
                                self.phoneLookupLists = data.Data.lookupLists;
                                self.phoneLookupLists.officeLocations = ko.observableArray(data.Data.lookupLists.OfficeLocations);
                                self.bvnProviderId = self.phoneLookupLists.BvnProviderId;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData, getModelCall).done(function (lookupData, data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phonenumber-edit-template', data: editPhoneModel }\"></div>");
                        self.filteredStatuses(ko.utils.arrayFilter(self.phoneLookupLists.PhoneNumberStatuses, function (item) {
                            if (self.editPhoneModel().CustomerId() > 0) {
                                return item.Text !== "Available" && item.Text !== "On Hold" && item.Text !== "Ported Out";
                            }
                            else {
                                return true;
                            }
                        }));
                        self.editPhoneModel().PhoneNumberProviderId.subscribe(function () {
                            self.filterProductTypes();
                        });
                        self.filterProductTypes();
                        ko.applyBindings(self, modal);
                        $("#CustomerId", modal).autocomplete({
                            source: function (request, response) {
                                tools.ajaxPost({
                                    url: "/Customers/findCustomerByName",
                                    data: { Name: self.editPhoneModel().CustomerName() },
                                    success: function (Results) {
                                        response($.map(Results.Data, function (item) { return ({
                                            label: item.Name,
                                            value: item.Id,
                                            OfficeLocations: item.OfficeLocations,
                                            BrandInternalId: item.BrandInternalId,
                                        }); }));
                                    }
                                });
                            },
                            change: function (event, ui) {
                                if (!ui.item) {
                                    self.editPhoneModel().CustomerId(0);
                                    self.editPhoneModel().BrandInternalId(-1);
                                    self.phoneLookupLists.officeLocations(null);
                                }
                            },
                            select: function (event, ui) {
                                var selectedObj = ui.item;
                                self.editPhoneModel().CustomerId(selectedObj.value);
                                self.editPhoneModel().BrandInternalId(selectedObj.BrandInternalId);
                                self.domainsDataSource.filter([
                                    { field: "CustomerId", operator: "eq", value: self.editPhoneModel().CustomerId() || -1 },
                                    { field: "includePhoneNumbers", operator: "eq", value: self.includePhoneNumbers }
                                ]);
                                self.campaignsDataSource.filter([
                                    { field: "BrandRefId", operator: "eq", value: self.editPhoneModel().BrandInternalId() || -1 },
                                ]);
                                self.phoneLookupLists.officeLocations(selectedObj.OfficeLocations);
                                return false;
                            },
                            focus: function (event, ui) {
                                this.value = ui.item.label;
                                event.preventDefault(); // Prevent the default focus behavior.
                            },
                            open: function (event, ui) {
                                $(this).autocomplete("widget").css("z-index", 1060);
                                $(this).keydown(function (e) {
                                    if (e.keyCode === 13) {
                                        $(".ui-menu-item:first a").click();
                                    }
                                });
                            }
                        });
                        $(function () {
                            $('[data-toggle="tooltip"]', modal).tooltip();
                        });
                        self.editPhoneModel().CustomerId.subscribe(function () {
                            self.filteredStatuses(ko.utils.arrayFilter(self.phoneLookupLists.PhoneNumberStatuses, function (item) {
                                if (self.editPhoneModel().CustomerId() > 0) {
                                    return item.Text !== "Available" && item.Text !== "On Hold" && item.Text !== "Ported Out";
                                }
                                else {
                                    return true;
                                }
                            }));
                        });
                        self.editPhoneModel().PhoneNumberProviderId.subscribe(function (value) {
                            var status = ko.utils.arrayFirst(self.phoneLookupLists.PhoneNumberProviders, function (item) {
                                return item.Value == value;
                            });
                            console.log('provider was changed: ', status);
                            self.includePhoneNumbers = status && status.Text.toLowerCase() == 'Bandwidth'.toLowerCase();
                            self.domainsDataSource.filter([
                                { field: "CustomerId", operator: "eq", value: self.editPhoneModel().CustomerId() || -1 },
                                { field: "includePhoneNumbers", operator: "eq", value: self.includePhoneNumbers }
                            ]);
                        });
                        var lookupDataSources = new LookupDataSources();
                        self.domainsDataSource = lookupDataSources.createLookupDataSource("CustomerEntityNames");
                        self.domainsDataSource.filter([
                            { field: "CustomerId", operator: "eq", value: self.editPhoneModel().CustomerId() || -1 },
                            { field: "includePhoneNumbers", operator: "eq", value: self.includePhoneNumbers }
                        ]);
                        self.domainsDropdown = $("#EntityName", modal).kendoComboBox({
                            dataSource: self.domainsDataSource,
                            dataTextField: "Text",
                            dataValueField: "Text",
                            valuePrimitive: true,
                            filter: "contains",
                        }).data("kendoComboBox");
                        self.domainsDropdown.wrapper.width("100%");
                        if (self.domainsDropdown) {
                            self.domainsDropdown.value(self.editPhoneModel().EntityName());
                        }
                        self.campaignsDataSource = lookupDataSources.createLookupDataSource("Campaigns");
                        self.campaignsDataSource.filter([
                            { field: "BrandRefId", operator: "eq", value: self.editPhoneModel().BrandInternalId() || -1 },
                        ]);
                        self.campaignsDropdown = $("input[name=CampaignInternalId]", modal).kendoDropDownList({
                            dataSource: self.campaignsDataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            optionLabel: "None",
                            popup: {
                                appendTo: $(".modal-body .CampaignInternalId", modal)
                            },
                            change: function (e) {
                                var dataItem = e.sender.dataItem();
                                if (dataItem) {
                                    self.editPhoneModel().CampaignInternalId(dataItem.Id);
                                }
                                else {
                                    self.editPhoneModel().CampaignInternalId("");
                                }
                            }
                        }).data("kendoDropDownList");
                        console.log('CampaignInternalId', self.editPhoneModel().CampaignInternalId());
                        if (self.campaignsDropdown) {
                            self.campaignsDropdown.value(self.editPhoneModel().CampaignInternalId());
                        }
                    });
                }
            });
        };
        PhoneNumberActions.prototype.filterProductTypes = function () {
            var self = this;
            self.filteredProductTypes(ko.utils.arrayFilter(self.phoneLookupLists.PhoneNumberTypes, function (item) {
                if (self.editPhoneModel().PhoneNumberProviderId() > 0) {
                    return item.Providers.indexOf(self.editPhoneModel().PhoneNumberProviderId()) > -1;
                }
                else {
                    return true;
                }
            }));
        };
        PhoneNumberActions.prototype.enableNumberEdit = function () {
            var self = this;
            self.editPhoneModel().NumberEditReadonly(false);
        };
        PhoneNumberActions.prototype.savePhoneNumber = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editPhoneModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            delete obj.CommentHtml;
            tools.ajaxPost({
                url: "/PhoneNumbers/SavePhoneNumber",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (result.Data.StsMessage) {
                        tools.error(result.Data.StsMessage);
                    }
                    if (_this.savePhoneCallback) {
                        _this.savePhoneCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        PhoneNumberActions.prototype.deleteNumberConfirm = function (phoneId, hasE911, phoneNumber) {
            var self = this;
            self.removePhoneModel(new RemovePhoneNumberModel());
            self.removePhoneModel().Id(phoneId);
            self.removePhoneModel().CanDeleteE911(self.userCanDeleteE911());
            self.removePhoneModel().HasE911(hasE911);
            self.removePhoneModel().userCanDeleteBrekeke(self.userCanDeleteBrekeke());
            self.removePhoneModel().deleteBrekeke(self.userCanDeleteBrekeke());
            tools.editModal({
                title: "Delete Phone Number - ".concat(phoneNumber),
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteNumber(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phonenumber-remove-template', data: removePhoneModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        PhoneNumberActions.prototype.deleteNumber = function (btn, modal) {
            var _this = this;
            var self = this;
            if (!self.removePhoneModel().StatusName()) {
                tools.error("Choose Reason");
                $(btn).button("reset");
                return;
            }
            if (self.removePhoneModel().HasE911() && self.removePhoneModel().ConfirmCode() !== "DELETE") {
                tools.error("Please enter correct confirmation code");
                $(btn).button("reset");
                return;
            }
            var escapedNotes = $("<div/>").text(self.removePhoneModel().ReasonNotes()).html();
            var data = {
                id: self.removePhoneModel().Id(),
                ids: self.removePhoneModel().NumbersIds(),
                reason: self.removePhoneModel().StatusName(),
                reasonNotes: escapedNotes,
                confirmCode: self.removePhoneModel().ConfirmCode(),
                deleteBrekeke: self.removePhoneModel().deleteBrekeke()
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/PhoneNumbers/DeletePhoneConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Phone deleted successfully");
                    if (_this.removePhoneCallback) {
                        _this.removePhoneCallback();
                    }
                    $(modal).modal("hide");
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        PhoneNumberActions.prototype.bulkDeletePhoneNumber = function (phoneNumbers) {
            var self = this;
            var numberIds = ko.utils.arrayMap(phoneNumbers, function (item) {
                return item.id;
            });
            var phoneWithE911 = ko.utils.arrayFirst(phoneNumbers, function (item) {
                return item.e911;
            });
            var hasE911 = false;
            if (phoneWithE911) {
                hasE911 = true;
            }
            self.removePhoneModel(new RemovePhoneNumberModel());
            self.removePhoneModel().CanDeleteE911(self.userCanDeleteE911());
            self.removePhoneModel().HasE911(hasE911);
            self.removePhoneModel().userCanDeleteBrekeke(self.userCanDeleteBrekeke());
            self.removePhoneModel().deleteBrekeke(self.userCanDeleteBrekeke());
            self.removePhoneModel().Numbers(phoneNumbers);
            self.removePhoneModel().NumbersIds(numberIds);
            tools.editModal({
                title: "Delete Phone Numbers",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteNumber(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phonenumber-remove-template', data: removePhoneModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        PhoneNumberActions.prototype.bulkEditPhoneNumber = function (phoneNumbers) {
            var self = this;
            self.bulkEditPhoneModel(new BulkEditPhoneNumberModel());
            var numberIds = ko.utils.arrayMap(phoneNumbers, function (item) {
                return item.id;
            });
            self.bulkEditPhoneModel().Numbers(phoneNumbers);
            self.bulkEditPhoneModel().NumbersIds(numberIds);
            tools.editModal({
                title: "Phone Numbers Bulk Edit",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (self.bulkEditPhoneModel().BulkEditPhoneNumberProvider() && !self.bulkEditPhoneModel().PhoneNumberProviderId()) {
                        tools.error("Please select provider");
                        return;
                    }
                    if (self.bulkEditPhoneModel().BulkEditCustomer() && (self.bulkEditPhoneModel().CustomerId() <= 0 || !self.bulkEditPhoneModel().CustomerName())) {
                        tools.error("Please select Customer");
                        return;
                    }
                    if (self.bulkEditPhoneModel().BulkEditCNam()) {
                        var notValidCnam = tools.validateCNam(self.bulkEditPhoneModel().CNam());
                        if (notValidCnam) {
                            tools.error(notValidCnam);
                            return;
                        }
                    }
                    $(event.currentTarget).button("loading");
                    self.saveBulkEditPhoneNumber(event.currentTarget, modal);
                },
                opened: function (modal) {
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: urls_1.urls.getPhoneGetLookupData,
                        success: function (data) {
                            if (data.Success) {
                                self.phoneLookupLists = data.Data.lookupLists;
                                self.filteredStatuses(ko.utils.arrayFilter(self.phoneLookupLists.PhoneNumberStatuses, function (item) {
                                    return item.Text !== "On Hold" && item.Text !== "Ported Out";
                                }));
                                self.phoneLookupLists.officeLocations = ko.observableArray(data.Data.lookupLists.OfficeLocations);
                                self.bvnProviderId = self.phoneLookupLists.BvnProviderId;
                                self.filterProductTypes();
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'bulk-phonenumber-edit-template', data: bulkEditPhoneModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.bulkEditPhoneModel().PhoneNumberProviderId.subscribe(function () {
                            self.filterProductTypes();
                        });
                        self.filterProductTypes();
                        $("#CustomerId", modal).autocomplete({
                            source: function (request, response) {
                                tools.ajaxPost({
                                    url: "/Customers/findCustomerByName",
                                    data: { Name: self.bulkEditPhoneModel().CustomerName() },
                                    success: function (Results) {
                                        response($.map(Results.Data, function (item) { return ({
                                            label: item.Name,
                                            value: item.Id,
                                            OfficeLocations: item.OfficeLocations
                                        }); }));
                                    }
                                });
                            },
                            select: function (event, ui) {
                                var selectedObj = ui.item;
                                self.bulkEditPhoneModel().CustomerId(selectedObj.value);
                                self.phoneLookupLists.officeLocations(selectedObj.OfficeLocations);
                                return false;
                            },
                            focus: function (event, ui) {
                                this.value = ui.item.label;
                                event.preventDefault(); // Prevent the default focus behavior.
                            },
                            open: function (event, ui) {
                                $(this).autocomplete("widget").css("z-index", 1060);
                                $(this).keydown(function (e) {
                                    if (e.keyCode === 13) {
                                        $(".ui-menu-item:first a").click();
                                    }
                                });
                            }
                        });
                        var lookupDataSources = new LookupDataSources();
                        self.bulkEditCampaignsDataSource = lookupDataSources.createLookupDataSource("Campaigns");
                        self.bulkEditCampaignsDataSource.filter([
                        //{ field: "BrandRefId", operator: "eq", value: self.editPhoneModel().BrandInternalId() || -1 },
                        ]);
                        self.bulkEditCampaignsDropdown = $("input[name=CampaignId]", modal).kendoDropDownList({
                            dataSource: self.bulkEditCampaignsDataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            optionLabel: "None",
                            popup: {
                                appendTo: $(".modal-body .CampaignId", modal)
                            },
                            change: function (e) {
                                var dataItem = e.sender.dataItem();
                                if (dataItem) {
                                    self.bulkEditPhoneModel().CampaignId(dataItem.Id);
                                }
                                else {
                                    self.bulkEditPhoneModel().CampaignId(undefined);
                                }
                            }
                        }).data("kendoDropDownList");
                        self.bulkEditPhoneModel().BulkEditCampaignId.subscribe(function (value) {
                            self.bulkEditCampaignsDropdown.enable(value);
                        });
                    });
                }
            });
        };
        PhoneNumberActions.prototype.saveBulkEditPhoneNumber = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.bulkEditPhoneModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/PhoneNumbers/SaveBulkEditPhoneNumber",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (result.Data) {
                        tools.error(result.Data);
                    }
                    if (_this.savePhoneCallback) {
                        _this.savePhoneCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                } /*else {
                    tools.error(result.Error);
                }*/
            }).always(function () {
                $(btn).button("reset");
            });
        };
        PhoneNumberActions.prototype.removeE911LocationConfirm = function (locationId) {
            var _this = this;
            tools.confirmModal({
                title: "Remove E911 Location",
                text: "Are you sure you want to Remove customer E911 location?",
                buttonTitle: "Remove",
                type: "info",
                modalOptions: {},
            }, function (modal) {
                $(modal).modal("hide");
                _this.removeE911Location(locationId);
            });
        };
        PhoneNumberActions.prototype.removeE911Location = function (locationId) {
            var _this = this;
            var data = {
                locationId: locationId
            };
            //data['__RequestVerificationToken'] = $('#mainCustomerForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/E911/RemoveLocationJson",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Location Removed successfully");
                    if (_this.removeE911Callback) {
                        _this.removeE911Callback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        PhoneNumberActions.prototype.removeE911UriConfirm = function (phoneNumber) {
            var _this = this;
            tools.confirmModal({
                title: "Remove E911 Phone Number from vendors API",
                text: "Are you sure you want to Remove customer E911 Phone Number from vendors API?",
                buttonTitle: "Remove",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                _this.removeE911Uri(phoneNumber);
            });
        };
        PhoneNumberActions.prototype.removeE911Uri = function (phoneNumber) {
            var _this = this;
            var data = {
                uri: phoneNumber
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/E911/RemovePhoneUriAction",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("E911 Uri Removed successfully");
                    if (_this.removeE911Callback) {
                        _this.removeE911Callback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        PhoneNumberActions.prototype.addE911Details = function (prefillData) {
            var self = this;
            tools.editModal({
                title: "Edit E911 Details",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editE911DetailsModel().CustomerId()) {
                        tools.error("Customer is required");
                        return;
                    }
                    if (!self.editE911DetailsModel().PhoneNumberId()) {
                        tools.error("Phone Number is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveE911Details(event.currentTarget, modal);
                },
                opened: function (modal) {
                    self.editE911DetailsModel(new E911DetailsModel());
                    //self.editE911DetailsModel().PhoneNumberId(phoneId);
                    //self.editE911DetailsModel().Uri(phoneNumber);
                    //self.editE911DetailsModel().TelephoneNumber(phoneNumber);
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'e911-edit-template', data: editE911DetailsModel }\"></div>");
                    ko.applyBindings(self, modal);
                    $("#CustomerId", modal).autocomplete({
                        source: function (request, response) {
                            tools.ajaxPost({
                                url: "/Customers/findCustomerByNameWithPhones",
                                data: { Name: self.editE911DetailsModel().CustomerName() },
                                success: function (Results) {
                                    response($.map(Results.Data, function (item) { return ({
                                        label: item.Name,
                                        value: item.Id,
                                        Numbers: item.Numbers
                                    }); }));
                                }
                            });
                        },
                        select: function (event, ui) {
                            var selectedObj = ui.item;
                            self.editE911DetailsModel().CustomerId(selectedObj.value);
                            self.customerNumbers(selectedObj.Numbers);
                            return false;
                        },
                        focus: function (event, ui) {
                            this.value = ui.item.label;
                            event.preventDefault(); // Prevent the default focus behavior.
                        },
                        open: function (event, ui) {
                            $(this).autocomplete("widget").css("z-index", 1060);
                            $(this).keydown(function (e) {
                                if (e.keyCode === 13) {
                                    $(".ui-menu-item:first a").click();
                                }
                            });
                        }
                    });
                }
            });
        };
        PhoneNumberActions.prototype.saveE911Details = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editE911DetailsModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/E911/SaveE911AddressDetails",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (_this.addE911Callback) {
                        _this.addE911Callback();
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        PhoneNumberActions.prototype.openPhoneHistory = function () {
        };
        PhoneNumberActions.prototype.editFaxSettings = function (phoneId, phoneNumber) {
            var self = this;
            var title = "Edit Fax Settings";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate   form
                    if (self.editFaxSettingsModel().OutboundEmails()) {
                        var outboundEmails = self.editFaxSettingsModel().OutboundEmails().split('\n');
                        var outIndex = 1;
                        for (var _i = 0, outboundEmails_1 = outboundEmails; _i < outboundEmails_1.length; _i++) {
                            var email = outboundEmails_1[_i];
                            if (!tools.isValidEmail(email)) {
                                tools.error("Outbound Email is not valid at line " + outIndex);
                                return;
                            }
                            outIndex++;
                        }
                    }
                    if (self.editFaxSettingsModel().InboundEmails()) {
                        var inboundEmails = self.editFaxSettingsModel().InboundEmails().split('\n');
                        var inIndex = 1;
                        for (var _a = 0, inboundEmails_1 = inboundEmails; _a < inboundEmails_1.length; _a++) {
                            var email = inboundEmails_1[_a];
                            if (!tools.isValidEmail(email)) {
                                tools.error("Outbound Email is not valid at line " + inIndex);
                                return;
                            }
                            inIndex++;
                        }
                    }
                    $(event.currentTarget).button("loading");
                    self.saveFaxSettings(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = tools.ajaxGet({
                        url: '/PhoneNumbers/FaxSettingsNumberById',
                        data: { id: phoneId },
                        success: function (result) {
                            if (result.Success) {
                                self.editFaxSettingsModel(new FaxSettingsModel(result.Data));
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'faxsettings-edit-template', data: editFaxSettingsModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        PhoneNumberActions.prototype.generatePassword = function () {
            return generator_1.RandomGenerator.generate({
                Length: 15,
                Type: 'Length',
                IncludeLowercase: true,
                IncludeNumbers: true,
                IncludeUppercase: true,
                IncludeFaxSpecial: true
            });
        };
        PhoneNumberActions.prototype.generatePasswordClick = function (data, event) {
            var self = this;
            self.editFaxSettingsModel().Password(self.generatePassword());
            event.preventDefault();
        };
        PhoneNumberActions.prototype.saveFaxSettings = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editFaxSettingsModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            delete obj.CommentHtml;
            tools.ajaxPost({
                url: "/PhoneNumbers/SaveFaxSettings",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (result.Data.StsMessage) {
                        tools.error(result.Data.StsMessage);
                    }
                    if (_this.savePhoneCallback) {
                        _this.savePhoneCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        return PhoneNumberActions;
    }());
    return PhoneNumberActions;
});
//# sourceMappingURL=phoneNumberActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumbers/phoneNumberActions.js
// module id = 16
// module chunks = 2